/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ProvisionDashboardUserResponse
 */
export interface ProvisionDashboardUserResponse {
  /**
   *
   * @type {string}
   * @memberof ProvisionDashboardUserResponse
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof ProvisionDashboardUserResponse
   */
  password: string;
}

/**
 * Check if a given object implements the ProvisionDashboardUserResponse interface.
 */
export function instanceOfProvisionDashboardUserResponse(
  value: object,
): value is ProvisionDashboardUserResponse {
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("password" in value) || value["password"] === undefined) return false;
  return true;
}

export function ProvisionDashboardUserResponseFromJSON(
  json: any,
): ProvisionDashboardUserResponse {
  return ProvisionDashboardUserResponseFromJSONTyped(json, false);
}

export function ProvisionDashboardUserResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ProvisionDashboardUserResponse {
  if (json == null) {
    return json;
  }
  return {
    email: json["email"],
    password: json["password"],
  };
}

export function ProvisionDashboardUserResponseToJSON(
  json: any,
): ProvisionDashboardUserResponse {
  return ProvisionDashboardUserResponseToJSONTyped(json, false);
}

export function ProvisionDashboardUserResponseToJSONTyped(
  value?: ProvisionDashboardUserResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    email: value["email"],
    password: value["password"],
  };
}
